// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"6ae6c8cb","616":"c1d4e9bd","634":"aeed368c","881":"5b6ad01a","937":"394b863c"}[chunkId] + ".chunk.css";
};